export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'SAMPLE': {
                'TITLE': 'Sample',
                'BADGE': '25'
            },
            'LOGIN': {
                'TITLE': 'Login'
            },
            'INSPETIONREPORT': {
                'TITLE': 'InspectionReport'
            }
        }
    }
};



// WEBPACK FOOTER //
// /vercel/path0/src/app/navigation/i18n/en.ts